import type { ReactNode } from 'react';
import { clsx } from 'clsx';

export interface GlassPanelProps {
  /** Content rendered inside the glass surface. */
  children?: ReactNode;
  /** When true, overlays the 52px bunker grid behind the content. */
  grid?: boolean;
  /** Additional classes merged onto the panel element. */
  className?: string;
  /** Semantic element to render as. Defaults to 'div'. */
  as?: 'div' | 'section' | 'article';
}

/**
 * GlassPanel
 *
 * The base glass surface every other brand primitive builds on:
 * background var(--panel), 1px var(--line) border, 8px radius, backdrop
 * blur and shadow (all supplied by the global `.glass-panel` recipe).
 *
 * When `grid` is enabled the content is wrapped in a relative `.bunker-grid`
 * container so the 52px grid overlay shows through. Purely structural — no
 * motion, so nothing to gate for reduced-motion.
 */
export function GlassPanel({
  children,
  grid = false,
  className,
  as = 'div',
}: GlassPanelProps) {
  const Element = as;

  return (
    <Element className={clsx('glass-panel', className)}>
      {grid ? (
        <div className="bunker-grid relative">{children}</div>
      ) : (
        children
      )}
    </Element>
  );
}

export default GlassPanel;
